const STORAGE_KEY = 'tracked_email';

export function resolveTrackedEmail(urlEmail?: string | null): string | undefined {
  if (urlEmail) {
    localStorage.setItem(STORAGE_KEY, urlEmail);
    return urlEmail;
  }
  return localStorage.getItem(STORAGE_KEY) ?? undefined;
}

export async function trackVisit(opts: {
  page: string;
  email?: string | null;
  referred_company?: string | null;
}) {
  const email = resolveTrackedEmail(opts.email ?? undefined);

  const ua = navigator.userAgent;
  let os = 'Other';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Mac')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';

  await fetch('https://fojubejaymmnxqsulnql.supabase.co/functions/v1/track-visitor', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      operating_system: os,
      user_agent: ua,
      page: opts.page,
      email,
      referred_company: opts.referred_company ?? undefined,
    }),
  });
}
